import { render, staticRenderFns } from "./polararea_component.vue?vue&type=template&id=4b5dbe12"
import script from "./polararea_component.vue?vue&type=script&lang=js"
export * from "./polararea_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports